/**
 * Ensure zero padding so that zeroPad(7, 3) === "007"
 */
export function zeroPad(value: string | number, ensureLength: number): string {
  const asString = String(Number(value));

  if (asString.length < ensureLength) {
    return (
      Array(ensureLength - asString.length)
        .fill('0')
        .join('') + asString
    );
  }

  return asString;
}

/**
 * Replace all <br/> with line break, then strip all HTML tags.
 */
export function stripHtmlTags(str: string): string {
  // @ts-ignore
  return typeof str === 'string' || str instanceof String
    ? str
        .replace(/<br\s*[\/]?>/gi, '\r\n')
        .replace(/<[^>]*>/g, '')
        .replace(/ +(?= )/g, '')
    : str;
}

export const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const isEmail = (str: string): boolean =>
  Boolean(
    str.match(
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    )
  );
